export default "/images/vendor/flag-icons/flags/1x1/cu.svg?b92f84c54d433ddeb07eaad87877d15d";